import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./modal.scss";

export const AcceptTermsModal = ({
  handleClose,
  show,
  handleAccept,
  selectedTitle,
}) => {
  return (
    <div>
      <Modal show={show} onHide={handleClose} className="z-50" centered>
        <Modal.Header closeButton>
          <Modal.Title>For deposits to: {selectedTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Yes, I ACCEPT Stripe banking terms of use! (www.https://stripe.com/legal/connect-account)
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
            variant="secondary"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
            onClick={handleAccept}
            variant="primary"
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
